<template>
  <h-msg-box
    v-model="showModal"
    class="financial-competition-modal"
    width="900"
    :footerHide="true"
    top="30"
    :mask-closable="false"
  >
    <p slot="header">
      <span class="signed-team-title">已报名队伍</span>
    </p>
    <div class="signed-team-list-main">
      <h-table
        :row-class-name="rowClassName"
        height="400"
        stripe
        :columns="columns"
        :data="dataList"
        :loading="tableLoading"
        noDataHeight="525"
        no-data-text="没有数据了"
      ></h-table>
      <div style="margin: 10px; height: 30px">
        <div style="float: right">
          <h-page
            size="small"
            show-sizer
            show-total
            show-elevator
            :total="pageTotal"
            :page-size-opts="[15, 20, 25, 30]"
            :current="params.page_num"
            :page-size="params.page_size"
            @on-change="handlePageChange"
            @on-page-size-change="handlePageSizeChange"
          />
        </div>
      </div>
    </div>
  </h-msg-box>
</template>

<script>
import Api from '@/api/competition/financialIndex'
import { mapGetters } from 'vuex'

export default {
  name: 'SignedTeams',
  props: {
    value: Boolean
  },
  computed: {
    ...mapGetters(['competeUser'])
  },
  data() {
    return {
      showModal: false,
      columns: [
        {
          title: '编号',
          width: 60,
          render: (h, { row: { _index } }) => {
            return h(
              'span',
              {},
              _index + 1 + this.params.page_size * (this.params.page_num - 1)
            )
          }
        },
        {
          title: '队伍名称',
          key: 'team_name'
        },
        {
          title: '队长',
          key: 'captainName',
          width: 100,
          render: (h, params) => {
            return h('span', {}, params.row['captainName'] || '-')
          }
        },
        {
          title: '成员',
          key: 'team_members',
          render: (h, { row: { team_members } }) => {
            if (team_members) {
              return h(
                'div',
                team_members.map((item) => {
                  return h(
                    'span',
                    {
                      style: {
                        display: 'inline-block',
                        padding: '0 6px',
                        margin: '5px',
                        border: 'solid 1px #85a3e0',
                        'border-radius': '2px',
                        background: '#ebf0fa',
                        color: '#1a75ff'
                      }
                    },
                    item.emp_name
                  )
                })
              )
            } else {
              return h('span', '--')
            }
          }
        },
        {
          title: 'round1答对题数',
          key: 'round1_score',
          width: 110
        },
        {
          title: 'round2得分',
          key: 'round2_score',
          width: 90
        }
      ],
      dataList: [],
      tableLoading: true,
      params: {
        page_num: 1,
        page_size: 15
      },
      pageTotal: 0
    }
  },
  created() {
    this.showModal = this.value
  },
  methods: {
    // 获取队伍人气值
    async getDataList() {
      this.tableLoading = true
      const { list, total } = await Api.queryCompetTeam(this.params)
      this.tableLoading = false
      this.pageTotal = total
      if (list && list.length) {
        list.forEach((item, index) => {
          item.isInTeam = this.judgeIsMyTeam(item)
          item.captainName = this.getCaptainName(item.team_members)
        })
        this.dataList = list
      } else {
        this.dataList = []
      }
    },
    // 处理分页变化
    handlePageChange(page_num) {
      this.params.page_num = page_num
      this.getDataList()
    },
    // 处理
    handlePageSizeChange(page_size) {
      this.params.page_size = page_size
      this.params.page_num = 1
      this.getDataList()
    },
    // 设置行样式
    rowClassName(row, index) {
      // 如果在队伍中，那么本行高亮
      if (row.isInTeam) {
        return 'hight-light-row'
      }
      return ''
    },
    // 判断是否为当前所处的队伍
    judgeIsMyTeam(item) {
      if (item.team_id === this.competeUser.team_id) {
        return true
      }
      return false
    },
    // 获取队长名称
    getCaptainName(members) {
      for (let i = 0, len = members.length; i < len; i++) {
        if (members[i].captain) {
          return members[i].emp_name
        }
      }
    }
  },
  watch: {
    value(newValue) {
      this.showModal = newValue
      if (this.showModal) {
        this.getDataList()
      }
    },
    showModal(val) {
      this.$emit('input', val)
      if (!val) {
        this.params.page_num = 1
      }
    }
  }
}
</script>

<style lang="scss">
.signed-team-title {
  font-family: 'PingFangSC-Medium', Arial, 'Microsoft Yahei', sans-serif,
    Verdana, 'PingFang SC';
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
}
.signed-team-list-main {
  width: 100%;
  margin-top: -8px;
  margin-bottom: 8px;
  .hight-light-row td {
    background-color: #fdf7ec !important;
  }
}
.top-wrap {
  display: flex;
}
.signed-team-tab-wrap {
  height: 40px;
  margin: 0 0 10px;
  display: flex;
  position: relative;
  top: -12px;
  flex: 1;
  span {
    width: 160px;
    text-align: center;
    line-height: 40px;
    box-sizing: border-box;
    border: 1px solid #d9d9d9;
    cursor: pointer;
    font-size: 16px;
    color: #333;
    &:hover {
      opacity: 0.8;
    }
  }
  .tab1 {
    border-right: none;
    border-radius: 4px 0 0 4px;
  }
  .tab2 {
    border-left: none;
    border-radius: 0 4px 4px 0;
  }
  .active {
    border: none;
    background-image: linear-gradient(42deg, #0037ff 0%, #8046f2 100%);
    color: #fff;
  }
}
.other-desc {
  font-size: 14px;
  color: #333;
  line-height: 32px;
  a {
    width: 172px;
    height: 32px;
    line-height: 32px;
    background-image: linear-gradient(42deg, #3060ff 0%, #5db7ff 100%);
    border-radius: 2px;
    border-radius: 2px;
    font-size: 14px;
    color: #fff;
    text-align: center;
    margin-left: 12px;
    display: inline-block;
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/MyTeam/SignedTeams.vue